/**
 * @author        luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright     Copyright (c) 2025, Zumper
 */

import { falseReducer, payloadReducer, trueReducer } from '@zcode/reducers'
import type { Messages } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleAction, handleActions } from 'redux-actions'
import {
  RECEIVE_STREAM_CONVERSATIONS_DATA,
  RECEIVE_STREAM_TOKEN_DATA,
  RECEIVE_STREAM_UNREAD_COUNTS,
} from '../constants'
import type { ActionTypes } from '../types'

export const streamUnreadCounts = combineReducers<Messages['streamUnreadCounts'], ActionTypes>({
  data: handleActions<Messages['streamUnreadCounts']['data'], ActionTypes>(
    {
      [RECEIVE_STREAM_UNREAD_COUNTS]: payloadReducer,
      [RECEIVE_STREAM_CONVERSATIONS_DATA]: (state, { payload }) => {
        return payload?.data.unreadCounts ?? null
      },
      [RECEIVE_STREAM_TOKEN_DATA]: (state, { payload }) => {
        return payload.unreadCounts
      },
    },
    null
  ),
})
